<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Ask to Join Again</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <p class="mt-3">
    Your request to join <b>{{ data?.accountName }}</b> will be sent to them again for review.
  </p>

  <!-- Shown because the message is being written as an answer to it. Having to close the dialog to reread
       what you are responding to is how somebody ends up answering the wrong objection. -->
  @if(data?.declineReason) {
    <div class="alert alert-warning">
      <mat-icon class="align-middle mr-2">feedback</mat-icon>
      <b>They said:</b> {{ data.declineReason }}
    </div>
  }

  <p class="text-muted">
    A short message helps whoever reviews this. They see the same request as last time unless you tell them
    what has changed, so anything that answers their reason above is worth adding. It is optional.
  </p>

  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Message (optional)</mat-label>
    <textarea
      matInput
      [(ngModel)]="reason"
      name="reason"
      rows="4"
      [maxlength]="maxLength"
      placeholder="For example: I started on Monday, my manager is Sam Taylor, and my staff number is 4471."></textarea>
    <mat-hint align="end">{{ reason.length }} / {{ maxLength }}</mat-hint>
  </mat-form-field>

  <!-- Offered rather than pre-filled. Retyping is what makes a second message worse than the first, but
       pre-filling would quietly resend identical text and defeat the point of asking. -->
  @if(data?.previousReason && reason !== data.previousReason) {
    <p>
      <!--
        Stroked and uncoloured on purpose. color="primary" made this a solid brand-orange block, because
        src/styles.scss carries `button.mat-primary { background: $primary-color !important; }`, which
        Angular Material applies to ANY button given color="primary" regardless of variant. That turned an
        optional convenience into the loudest thing in the dialog, competing with Send Request.

        Stroked matches how the rest of the product renders a subtle inline action (accounts filter, RBAC
        roles, system banners), and leaving the colour off keeps it clear of that global override.
      -->
      <button type="button" mat-stroked-button (click)="onReusePrevious()"
              matTooltip="Copy the message you sent last time into the box so you can edit it.">
        <mat-icon>content_copy</mat-icon>
        Use my previous message
      </button>
    </p>
  }

  <!-- Said before they commit, not after. The cap is the reason this decision carries any weight, and
       finding out afterwards that it was the final attempt is no use to anybody. -->
  @if(data?.attemptsRemaining === 1) {
    <div class="alert alert-info">
      <mat-icon class="align-middle mr-2">info</mat-icon>
      This is the last time you can ask <b>{{ data?.accountName }}</b> to join. If it is declined again you
      will need to contact them directly, though they can still approve your request at any point.
    </div>
  }
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onConfirm()">
      <mat-icon>send</mat-icon> Send Request
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onCancel()">
      <mat-icon>close</mat-icon> Cancel
    </button>
  </div>
</mat-dialog-actions>
